import { PlanogramLevel } from "../models/planogram-level";

export class UpdateSettingsRequest{
    planogramId: string = '';
    stateId: string | null = null;
    levels : PlanogramLevel[];
    settings : any = {};
    constructor(planogramId: string, stateId: string | null, levels: PlanogramLevel[], settings: any){
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.levels = levels;
        this.settings = settings;
    }
}

